import { api, ApiError, type User } from '../api.ts';
import { el, field } from '../ui.ts';

export function loginView(onLogin: (u: User) => void): HTMLElement {
  const email = el('input', { type: 'email', autocomplete: 'username', required: true });
  const password = el('input', { type: 'password', autocomplete: 'current-password', required: true });
  const error = el('p', { class: 'error' });
  const form = el('form', { class: 'login', onSubmit: async (e: Event) => {
    e.preventDefault();
    error.textContent = '';
    try {
      onLogin(await api.login(email.value, password.value));
    } catch (err) {
      error.textContent = err instanceof ApiError ? err.message : 'sign-in failed';
    }
  } },
    el('h1', {}, 'TEXTBOX content'),
    field('Email', email),
    field('Password', password),
    error,
    el('button', { type: 'submit', class: 'primary' }, 'Sign in'),
  );
  return el('div', { class: 'login-wrap' }, form);
}
